import i18next from 'i18next';

export default function initI18n() {
  i18next.addResourceBundle('en', 'ai-tool', {
    askBooleanQuestion: 'Ask yes/no question',
    askBooleanQuestionReasoning: 'Asking a yes/no question',
    askBooleanQuestionOutput: 'Saving yes/no answer',
    askBooleanQuestionError: 'Error saving yes/no answer',
    askMultipleChoiceQuestion: 'Ask multiple choice question',
    askMultipleChoiceQuestionReasoning: 'Asking a multiple choice question',
    askMultipleChoiceQuestionOutput: 'Saving multiple choice answer',
    askMultipleChoiceQuestionError: 'Error saving multiple choice answer',
    askScaleQuestion: 'Ask number scale question',
    askScaleQuestionReasoning: 'Asking a number scale question',
    askScaleQuestionOutput: 'Saving number scale answer',
    askScaleQuestionError: 'Error saving number scale answer',
    askQuestionSequence: 'Ask question sequence',
    askQuestionSequenceReasoning: 'Asking a sequence of questions',
    askQuestionSequenceOutput: 'Saving question sequence answers',
    askQuestionSequenceError: 'Error saving question sequence answers',
    extractWebPage: 'Extract web page',
    extractWebPageReasoning: 'Extracting web page',
    extractWebPageOutput: 'Extracted {{count}} web page(s)',
    extractWebPageNoop: 'No web pages extracted',
    extractWebPageError: 'Error extracting web page',
    getWeather: 'Get weather',
    getWeatherReasoning: 'Getting weather',
    getWeatherOutput: 'Got weather',
    getWeatherError: 'Error getting weather',
    searchTheWeb: 'Search the Web',
    searchTheWebReasoning: 'Searching the Web',
    searchTheWebOutput: 'Found {{count}} web results',
    searchTheWebNoop: 'No web results found',
    searchTheWebError: 'Error searching the Web',
    artifacts: 'Create artifact',
    artifactsReasoning: 'Creating artifact',
    artifactsOutput: 'Artifact created',
    artifactsError: 'Error creating artifact',
  });
}
